export namespace ArrayHelper {
    export function isEmpty(value: any[] | undefined): boolean {
        if (value === null) {
            return true;
        }

        if (value === undefined) {
            return true;
        }

        return value.length <= 0;
    }

    export function isNotEmpty(value?: any[] | undefined): boolean {
        return !isEmpty(value);
    }

}


